export const SET_TOGGLE_IDS = 'SET_TOGGLE_IDS';
export const SET_TABLE_COLUMN_PREFRENCES = 'SET_TABLE_COLUMN_PREFRENCES'
export const SET_DEFAULT_FILTER_CONFIG_FLAG = 'SET_DEFAULT_FILTER_CONFIG_FLAG';
export const SET_SIDEBAR_STATE = 'SET_SIDEBAR_STATE';
export const SET_AC_AND_DC_TOGGLE_STATE= 'SET_AC_AND_DC_TOGGLE_STATE';